import { Warning } from "@phosphor-icons/react";
import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader } from "./primitives";

const Legal = () => {
  const config = useSiteConfig();
  return (
    <section id="legal" className="relative py-24 lg:py-32 border-t border-line" data-testid="legal-section">
      <div className="section-shell">
        <SectionHeader
          index={18}
          eyebrow="Legal"
          title="Risk Disclosure & Disclaimer"
          testId="legal-header"
        />
        <Reveal delay={0.1}>
          <div className="mt-12 card-surface rounded-xl p-8 lg:p-12" data-testid="legal-panel">
            <div className="flex items-center gap-3 text-gold">
              <Warning size={24} aria-hidden="true" />
              <span className="font-mono text-xs tracking-[0.3em] uppercase">Please Read Carefully</span>
            </div>
            <ul className="mt-8 grid gap-x-10 gap-y-4 sm:grid-cols-2">
              {config.legal.points.map((point, i) => (
                <li key={i} className="flex items-start gap-3 text-sm text-slate leading-relaxed" data-testid={`legal-point-${i}`}>
                  <span className="mt-[7px] h-1.5 w-1.5 rounded-full bg-gold shrink-0" aria-hidden="true" />
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Legal;
